import React, { useState } from "react";
import "./paymentlist.css";

// components imports
import ShipperPaymentsTable from "../../../../../Components/BoltTable/BoltTable";
import AddBalance from "../AddBalance/AddBalance";
import PaymentsHistory from "../../../UserRegistration/Components/PaymentsHistory/PaymentsHistory";
import Tooltip from "../../../../../Components/Tooltip/Tooltip";

// apis imports
import { fetchAllShippers } from "../../../../../services/AdminServices/PaymentsAdmin/payments.services";

// library imports
import { MdOutlineHistory } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { convertTime } from "../../../../../helpers/helpers";
import { useTranslation } from "react-i18next";

const PaymentList = ({ setSnack, snack }) => {
  const { t } = useTranslation("admin");
  const [payments, setPayments] = useState([]);

  const [addBalanceModal, setAddBalanceModal] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);

  const getShippersPayments = async (page, perPage, filter) => {
    const response = await fetchAllShippers(page, perPage, filter);
    if (!response.error) {
      setPayments(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const columns = [
    {
      id: 0,
      label: "#",
      render: (row) => <>{row?.id ?? "-"}</>,
      width: "200px",
    },
    {
      id: 1,
      label: t("payments.userType"),
      render: (row) => <>{row?.role ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("payments.userName"),
      render: (row) => <>{row?.username ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("payments.businessName"),
      render: (row) => <>{row?.business_name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 4,
      label: t("payments.email"),
      render: (row) => <>{row?.email ?? "-"}</>,
      width: "200px",
    },
    {
      id: 5,
      label: t("payments.balance"),
      render: (row) => <>{row?.balance ?? "-"}</>,
      width: "200px",
    },
    {
      id: 6,
      label: t("payments.createdAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
    {
      id: 7,
      label: t("payments.actions"),
      render: (row) => (
        <div className="table_action__wrap">
          <Tooltip title={t("payments.addUserBalance")}>
            <div
              className="table_action__btn"
              onClick={() => setAddBalanceModal(row)}
            >
              <FaRegEdit size={10} />
              {t("payments.addBalance")}
            </div>
          </Tooltip>
          <Tooltip title={t("payments.viewUserTransactionHistory")}>
            <div
              className="table_action__btn"
              onClick={() => setHistoryModal(row)}
            >
              <MdOutlineHistory size={10} />
              {t("payments.transactions")}
            </div>
          </Tooltip>
        </div>
      ),
      width: "200px",
      fixed: "right",
    },
  ];

  return (
    <div>
      <div>
        <AddBalance
          open={addBalanceModal}
          setOpen={setAddBalanceModal}
          setSnack={setSnack}
          snack={snack}
          setPayments={setPayments}
        />
        <PaymentsHistory
          open={historyModal}
          setOpen={setHistoryModal}
          User={historyModal}
          setSnack={setSnack}
        />
        <ShipperPaymentsTable
          tableTitle={t("payments.payments")}
          tableId="adminpaymentsTableForAdmin"
          message={t("payments.noPaymentsAvailableToDisplay")}
          searchPlaceHolder={t("payments.searchPayments")}
          columns={columns}
          data={payments}
          getAllData={getShippersPayments}
        />
      </div>
    </div>
  );
};

export default PaymentList;
